import React from 'react';
import PropTypes from 'prop-types';
import classes from './StatusIcon.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/utils/Language/StatusIcon-translations';
import ReferralStatuses from '@/utils/referral_statuses';
import { accessEventHelpers } from '@/utils/helpers';
import capitalize from 'lodash/capitalize';

const StatusIcon = (props) => {
  const accessEvent = props.accessEvent || props.access_event_origin?.access_event;
  const status = accessEvent?.status;
  const withIcon = typeof props.withIcon == undefined ? true : props.withIcon;
  const isClr = props.isClr;
  let statusLabel = '';
  const getStatusLabel = (status) => {
    if (accessEvent && status) {
      if (props.useMemberLabels) {
        statusLabel =
          isClr && typeof ReferralStatuses.memberLabels[status]['is_clr'] !== 'undefined'
            ? ReferralStatuses.memberLabels[status]['is_clr']
            : ReferralStatuses.memberLabels[status]['is_not_clr'];
      } else if (['planned', 'unsuccessful', 'rejected'].indexOf(status) >= 0) {
        if (!isClr) {
          statusLabel = ReferralStatuses.labels[status]['is_not_clr'];
        } else {
          if (status == 'planned') {
            statusLabel = ReferralStatuses.labels['planned']['is_clr'];
          } else {
            statusLabel =
              ReferralStatuses.labels[status]['is_clr'][
                accessEventHelpers.isClosedLoopReferral(accessEvent) ? 'is_access_event_clr' : 'is_access_event_not_clr'
              ];
          }
        }
      } else if (status == 'accessed') {
        statusLabel = props.accessEvent.direct_access ? 'Pending enrollment' : status;
      } else {
        statusLabel = status;
      }
    }
    return t(capitalize(statusLabel).replace(/_/g, ' '));
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'planned':
        if (isClr) {
          return { class: 'share', color: '#FFD25E' };
        } else {
          return { class: 'clock', color: '#39BF69' };
        }
      case 'sent':
        return { class: 'share', color: '#39BF69' };
      case 'assigned':
        return { class: 'user-plus', color: '#39BF69' };
      case 'reassigned':
        return { class: 'exchange', color: '#39BF69' };
      case 'acknowledged':
        return { class: 'eye', color: '#39BF69' };
      case 'reminder':
        return { class: 'bell', color: '#39BF69' };
      case 'rejected':
        return { class: 'thumbs-down', color: '#C73539' };
      case 'unsuccessful':
        return { class: 'times-circle', color: '#C73539' };
      case 'accessed':
        if (props.accessEvent.direct_access) {
          return { class: 'exchange', color: '#39BF69' };
        } else {
          return { class: 'check-circle', color: '#39BF69' };
        }
      case 'utilized':
        return { class: 'check-circle', color: '#39BF69' };
      case 'in_progress':
        return { class: 'clock', color: '#000' };
      default:
        return { class: 'share', color: '#000' };
    }
  };

  return (
    <>
      <span className={classes.statusIcon}>
        {withIcon && (
          <>
            <FontAwesomeIcon icon={['fas', getStatusIcon(status).class]} color={getStatusIcon(status).color} />
            &nbsp;
          </>
        )}
        {t(getStatusLabel(status))}
      </span>
    </>
  );
};

StatusIcon.propTypes = {
  access_event_origin: PropTypes.object,
  accessEvent: PropTypes.object,
  isClr: PropTypes.bool
};

export default StatusIcon;
